import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const InformationBoxWrapper = styled.div`
  display: flex;
  margin: 16px 0px;

  ${responsive.MOBILE`
    padding: 16px 0;
    margin: 0;
  `}
  align-items: center;
  .line {
    display: block;
    width: 2px;
    height: 48px;
    border: 3px solid ${COLORS.primary_light_blue3};
    border-radius: 4px;
  }
  .text {
    line-height: 24px;
    padding-left: 8px;
    color: ${COLORS.cirrus_black10};
    line-height: 24px;
  }
  .full-width {
    width: 100%;
  }
`;
